import { ReactElement } from 'react';
// import { createHeadlessEditor } from '@lexical/headless';
// import { theme } from './RichTextEditor.css';
// import { nodes } from './nodes';
// import { $generateHtmlFromNodes } from '@lexical/html';
import type { EditorValue } from './types';
import { shell } from './RichTextEditor.css';

// function onError(error: any) {
//   console.error(error);
// }

// const sharedHeadlessEditor = createHeadlessEditor({ onError, nodes, theme });

export function RichTextRenderer({ value }: { value: EditorValue }): ReactElement {
  if (!value) {
    return <div />;
  }

  // Legacy fallback: parse state and generate HTML if needed
  // const html = useMemo(() => {
  //   if (!lexicalState) {
  //     return '';
  //   }
  //
  //   if (lexicalState.html) {
  //     return lexicalState.html;
  //   }
  //
  //   const editorState = sharedHeadlessEditor.parseEditorState(lexicalState.state);
  //   let htmlString = '';
  //
  //   editorState.read(() => {
  //     htmlString = $generateHtmlFromNodes(sharedHeadlessEditor, null);
  //   });
  //
  //   return htmlString;
  // }, [lexicalState]);

  // biome-ignore lint/security/noDangerouslySetInnerHtml: safe from lexical
  return <div className={shell} dangerouslySetInnerHTML={{ __html: value.html }} />;
}
